import { modifier } from 'ember-modifier';

interface EmbedPdfModifier {
  Args: {
    Positional: [string, string?];
  };
  Element: HTMLElement;
}

/**
 * <div {{embed-pdf @url}} />
 * <div {{embed-pdf @url @title}} />
 */
export default modifier<EmbedPdfModifier>((element, [url, title]) => {
  if (!url) {
    return;
  }
  const parent = element.parentElement;
  if (!parent) {
    console.error('embed-pdf modifier must be used on an element with a parent');
    return;
  }

  const bounds = parent.getBoundingClientRect();
  const width = `${bounds.width}px`;
  const height = `${bounds.height}px`;

  const embed = document.createElement('embed');
  embed.id = 'embed-pdf';
  embed.setAttribute('width', width);
  embed.setAttribute('height', height);
  embed.setAttribute('src', url);
  if (title) {
    embed.setAttribute('title', title);
  }
  element.replaceChildren(embed);

  const resizeHandler = function () {
    const bounds = parent.getBoundingClientRect();
    embed.setAttribute('width', `${bounds.width}px`);
    embed.setAttribute('height', `${bounds.height}px`);
  };

  window.addEventListener('resize', resizeHandler);

  return () => window.removeEventListener('resize', resizeHandler);
});
